<template>
  <SideBar>
    <template #side-bar-activator>
      <Activator
        class="self-centered cursor-e-resize"
        :key="`side_bar_activator>`"
        @mousedown.native="$router.push({
          name: 'ProjectTaktPlan',
          })"
        />
    </template>
    <template #content>
      <v-tabs fixed-tabs>
        <v-tab
          :to="{name: 'ProjectMilestones'}"
          >
          Project
        </v-tab>
        <v-tab
          :to="{name: 'TrainMilestones'}"
          >
          Train
        </v-tab>
      </v-tabs>
      <router-view/>
    </template>
  </SideBar>
</template>
<script>
import SideBar from '@/components/ProjectTaktPlan/SideBar.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'

import { MilestonesMixin } from '@/mixins/Milestones.mixin.js'
export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id'],
  components: {
    SideBar,
    Activator,
  },
  mixins: [
    MilestonesMixin
  ],
  data: () => ({
  }),
  computed: {
  },
}
</script>
